import { FC, HTMLAttributes } from 'react';
import BackArrow from '../../assets/back_arrow.png';
import { Trans } from 'react-i18next';
import { DesktopBackButtonProps } from './desktopBackButton.type';
import { getIdAttributes } from '../../utils/helper';

const DesktopBackButton: FC<
  DesktopBackButtonProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const idPrefix = 'desktop-back-button';
  return (
    <div
      {...getIdAttributes(idPrefix, 'container')}
      className="text-base flex gap-4 items-center mb-8 justify-start cursor-pointer"
      onClick={props.onClick}
    >
      <img src={BackArrow} alt="Back Arrow" className="w-5 h-4" />
      <span>
        <Trans i18nKey="login.backTo" />{' '}
        <span className="underline text-black">
          <Trans i18nKey="login.title" />
        </span>
      </span>
    </div>
  );
};

export default DesktopBackButton;
